import { Route } from '@angular/router';
import { KIDS_BUCHUNG_PATH } from '../mgs-path-defs';
import { kidsBuchungResolver } from './kids-buchung.resolver';

export const kidsBuchungRoute: Route = {
  path: KIDS_BUCHUNG_PATH,
  title: 'Kids & Teens Reservierung',
  loadComponent: () => import('./kids-buchung.component'),
  resolve: { kidsDaten: kidsBuchungResolver }
};
